<template>
  <role-form :role="role"></role-form>
</template>

<script>
import RoleForm from './roleForm'
import {Role} from '../../../object'

export default {
  name: 'NewRole',
  components: {RoleForm},
  data: () => ({
    role: null,
  }),
  created () {
    this.role = new Role()
    console.log('new ROle', this.role)
  }
}
</script>

<style scoped>

</style>
